;(function () {
  'use strict';

  /**
   * お問い合わせモーダル
   */
  var contactModal = {
    /**
     * 初期化
     */
    init: function (options) {
      var config = $.extend({
        dialog: '.ui-dialog--contact',          // ダイアログのセレクタ
        sideMargin: 15,                         // 左右の余白 [px]
        openButton: '.js-dialog--contact__open' // ダイアログの表示ボタン
      }, options);

      if ($('body.sp-viewport').length) {
        // sp版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: $(window).width() - (config.sideMargin * 2),
          position: {
            my: 'center top',
            at: 'center top+20',
            of: $('#content')
          },
          dialogClass: 'dialog-contact',
          show: 'fade',
          hide: 'fast'
        });
      } else {
        // pc版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          buttons: [
            {
              text: '閉じる',
              class: 'ui-dialog__button ui-dialog__button--cancel',
              click: function () {
                return $(this).dialog('close');
              },
            },
          ],
          width: 300,
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-contact',
          show: 'fade',
          hide: 'fast'
        });
      }

      /**
       * ログインモーダル 表示イベント
       */
      $(config.openButton).on('click', function () {
        $(config.dialog).dialog('open');
        return false;
      });

      /**
       * ログインモーダル 非表示イベント
       */
      $(config.closeButton).on('click', function () {
        $(config.dialog).dialog('close');
        return false;
      });

      //ダイアログ以外の場所をタップしたらダイアログが消える
      $(document).on('click', '.ui-widget-overlay', function () {
        $('#contact-dialog .ui-dialog-content .ui-widget-content').dialog('close');
      });
    }
  };

  /**
   * DOM content loaded
   */
  $(function () {
    contactModal.init();
  });
}.call(this));
